/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Empty } from '../models/empty';
import { outOfStock } from '../fn/availability/out-of-stock';
import { OutOfStock$Params } from '../fn/availability/out-of-stock';
import { outOfStockBulk } from '../fn/availability/out-of-stock-bulk';
import { OutOfStockBulk$Params } from '../fn/availability/out-of-stock-bulk';
import { PaginatedAvailabilityPerStoreResult } from '../models/paginated-availability-per-store-result';
import { storesStoreIdCatalogEntriesAvailabilityGet } from '../fn/availability/stores-store-id-catalog-entries-availability-get';
import { StoresStoreIdCatalogEntriesAvailabilityGet$Params } from '../fn/availability/stores-store-id-catalog-entries-availability-get';

@Injectable({ providedIn: 'root' })
export class AvailabilityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storesStoreIdCatalogEntriesAvailabilityGet()` */
  static readonly StoresStoreIdCatalogEntriesAvailabilityGetPath = '/stores/{storeId}/catalog-entries/availability';

  /**
   * Gets availabilities for a store.
   *
   * Retrieves paginated availability records for a store. itemType and outOfStockChannel are optional and independent - omitting both preserves existing caller behavior (returns every item unfiltered). Example combining both: ?itemType=PRODUCT&outOfStockChannel=any_channel
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdCatalogEntriesAvailabilityGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdCatalogEntriesAvailabilityGet$Response(params: StoresStoreIdCatalogEntriesAvailabilityGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedAvailabilityPerStoreResult>> {
    return storesStoreIdCatalogEntriesAvailabilityGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets availabilities for a store.
   *
   * Retrieves paginated availability records for a store. itemType and outOfStockChannel are optional and independent - omitting both preserves existing caller behavior (returns every item unfiltered). Example combining both: ?itemType=PRODUCT&outOfStockChannel=any_channel
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdCatalogEntriesAvailabilityGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdCatalogEntriesAvailabilityGet(params: StoresStoreIdCatalogEntriesAvailabilityGet$Params, context?: HttpContext): Observable<PaginatedAvailabilityPerStoreResult> {
    return this.storesStoreIdCatalogEntriesAvailabilityGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedAvailabilityPerStoreResult>): PaginatedAvailabilityPerStoreResult => r.body)
    );
  }

  /** Path part for operation `outOfStock()` */
  static readonly OutOfStockPath = '/stores/{storeId}/availability/out-of-stock';

  /**
   * Mark an item as out-of-stock for a store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outOfStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outOfStock$Response(params: OutOfStock$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return outOfStock(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark an item as out-of-stock for a store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outOfStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outOfStock(params: OutOfStock$Params, context?: HttpContext): Observable<Empty> {
    return this.outOfStock$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

  /** Path part for operation `outOfStockBulk()` */
  static readonly OutOfStockBulkPath = '/stores/{storeId}/availability/out-of-stock/bulk';

  /**
   * Mark multiple items as out-of-stock for a store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outOfStockBulk()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outOfStockBulk$Response(params: OutOfStockBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return outOfStockBulk(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark multiple items as out-of-stock for a store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outOfStockBulk$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outOfStockBulk(params: OutOfStockBulk$Params, context?: HttpContext): Observable<Empty> {
    return this.outOfStockBulk$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

}
